import { render } from "./HomeSection.vue?vue&type=template&id=3296dc62&scoped=true"
import script from "./HomeSection.vue?vue&type=script&lang=js"
export * from "./HomeSection.vue?vue&type=script&lang=js"

import "./HomeSection.vue?vue&type=style&index=0&id=3296dc62&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3296dc62"]])

export default __exports__